import "./AboutUs.css";

import React from "react";
import { useEffect } from "react";

import { Link } from "react-router-dom";

import { AboutUsModal } from "./AboutUsModal";
import { SectionFour } from "../FrontPage/frontPageSections/SectionFour/SectionFour";
import { SectionTwoCard } from "../FrontPage/frontPageSections/SectionTwo/SectionTwoCard";
import sectionTwoSignatureIcon from "../../shared/imageAssets/sectionTwoSignatureIcon.png";
import sectionTwoIcon1 from "../../shared/imageAssets/sectionTwoIcon1.png";
import sectionTwoIcon2 from "../../shared/imageAssets/sectionTwoIcon2.png";
import sectionTwoIcon3 from "../../shared/imageAssets/sectionTwoIcon3.png";
import sectionTwoIcon4 from "../../shared/imageAssets/sectionTwoIcon4.png";



export const AboutUs = ({ changeNavBar }) => {
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "about-us") {
      changeNavBar("isAboutUs", "rgba(41, 41, 41)", "white", "13rem", "row");
    }
  }, []);
  return (
    <div className="about-us-contaienr">
      <div className="about-us-title-section">
        <h1 className="about-us-title">За нас</h1>

        
      </div>
      <div className="about-us-content">
        <div className="about-us-section-one-container">
          <SectionTwoCard
            singleCard={true}
            headerText=""
            titleText=""
            contentText='"Нови Футболни Обувки" ЕООД внася маркови спортни стоки в България.
             От 3 години ние сме най-добрият спортен магазин в България.
              Нашата цел е да помагаме както на професионални футболисти, така и на любители на спорта.
               Ние предлагаме всякакви спортни стоки.'
            imgSingleCard={sectionTwoSignatureIcon}
          />
          <div className="about-us-section-one-modal-button-container">
            <AboutUsModal />
          </div>
        </div>
        <div className="about-us-section-two-container">
          <SectionTwoCard
            style={{ mr: "auto", ml: "auto" }}
            multyCard={true}
            imgMultyCard={sectionTwoIcon1}
            titleText=""
            contentText=""
          />
          <SectionTwoCard
            multyCard={true}
            imgMultyCard={sectionTwoIcon2}
            titleText=""
            contentText=""
          />
          <SectionTwoCard
            multyCard={true}
            imgMultyCard={sectionTwoIcon3}
            titleText=""
            contentText=""
          />
        </div>
        <SectionFour />
      </div>
    </div>
  );
};
